// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fix-col[data-v-4f14c092]{width:200px}.phone-col[data-v-4f14c092]{width:292px}.remain-col[data-v-4f14c092]{width:calc(100% - 492px)}.module-section[data-v-4f14c092]{height:600px}", ""]);
